import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  categoryHolder: {
    flexDirection: 'column', alignItems: 'center'
  },
  categoryTitle: {
    display: 'flex', alignItems: 'center'
  },
  categoryIcon: {
    color: 'dimgray'
  },
  categoryIconWarning: {
    color: 'darkorange'
  },
  categoryIconWhite: {
    color: 'white'
  },
  categoryTitleText: {
    marginLeft: '8px', marginRight: '8px'
  },
  subtitle: {
    backgroundColor: 'red'
  },    
  address2: {
    display: 'flex', alignItems: 'center', justifyContent: 'left',
  },
  thumbsUpDownText: {
    display: 'flex', flexDirection: 'row', textAlign: 'center', justifyContent: 'center'
  },
  thumbsUpDown: {
    display: 'flex', flexDirection: 'row', justifyContent: 'center', justifyItems: 'center'
  },
  thumbsUpIcon: {
    color: 'dimgray'
  },
  thumbsUpIconHighlight: {
    color: 'blue'
  },
}));